/* eslint-env browser */

import isObject from 'lodash/isObject';

export default function defaultValue() {
  if (!isObject(document)) {
    return {};
  }
  var _window = window,
      _window$location = _window.location,
      location = _window$location === undefined ? {} : _window$location;

  return {
    name: document.title,
    url: location.href,
    id: location.href
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/object-defaults-browser.js
// module id = 1189
// module chunks = 0